<template>
    <div class="h-100">
      <b-col class="settings-panel">
          <div class="card">
              <div class="card-header">
                  App Update Settings
              </div>
              <b-row>
                  <b-col md="12" class="settings-panel-body appupdate">
                      <div class="card-block">
                          <b-form>
                              <div>
                                  <legend class="mb-3">Temp directory permission</legend>
                                  <div class="helper-text">This directory will be used as a temporary directory while updating the panel and installing/updating the addons.</div>
                                  <div class="status-text">
                                      <span v-if="dirSettings.appDirPermission.updates===1">
                                          <success-filled-icon class="icon-default success absolute"></success-filled-icon>
                                          <span class="pl-4 label-desc">Temp directory is writable.</span>
                                      </span>
                                      <span v-else>
                                          <error-filled-icon class="icon-default error absolute"></error-filled-icon>
                                          <span class="pl-4 label-desc">Temp directory is not writable.</span>
                                      </span>
                                  </div>
                              </div>
                            </b-form>
                              <hr>
                            <b-form>
                              <div>
                                  <legend class="mb-3">Uploads directory permission</legend>
                                  <div class="helper-text">This directory will be used to store uploaded files and some files created by the panel.
                                  </div>
                                  <div class="status-text">
                                      <span v-if="dirSettings.appDirPermission.uploads===1">
                                          <success-filled-icon class="icon-default success absolute"></success-filled-icon>
                                          <span class="pl-4 label-desc">[IWP Admin Panel]/uploads is writable.</span>
                                      </span>
                                      <span v-else>
                                          <error-filled-icon class="icon-default error absolute"></error-filled-icon>
                                          <span class="pl-4 label-desc">[IWP Admin Panel]/uploads is not writable.</span>
                                      </span>
                                  </div>
                              </div>
                            </b-form>
                              <hr>
                            <b-form>
                              <b-form-group>
                                  <label>File system type</label>
                                  <b-form-radio-group button-variant="outline-custom" buttons v-model="form.isDirectFS" :options="options" class="active"></b-form-radio-group>
                              </b-form-group>
                              <div class="label-desc pl-2" v-if="form.isDirectFS=='Y'">If this method is chosen, it will try to update using direct filesystem which is the default method of updating.</div>
                              <div class="label-desc pl-2" v-if="form.isDirectFS=='N'">Your IWP Panel FTP credentials will be used for upgrades when the files can not be accessed directly.</div>
                              <b-form-group class="pl-1 pt-4" v-if="form.isDirectFS=='N'">
                                  <b-row>
                                      <b-col cols="4">
                                          <b-form-group class="p-0" id="exampleInputGroup3" label="FTP host" label-for="smtp_host">
                                              <b-form-input id="smtp_host" type="text" v-model="form.ftpDetails.HOST" required >
                                              </b-form-input>
                                          </b-form-group>
                                      </b-col>
                                      <b-col cols="4">
                                          <b-form-group class="p-0" id="exampleInputGroup3" label="FTP port" label-for="smtp_port">
                                              <b-form-input id="smtp_port" type="text" v-model="form.ftpDetails.PORT" required >
                                              </b-form-input>
                                          </b-form-group>
                                      </b-col>
                                      <b-col>
                                          <b-form-group class="p-0" id="exampleInputGroup3" label="FTP base" label-for="ftp_base">
                                              <b-form-input id="ftp_base" type="text" v-model="form.ftpDetails.BASE" required >
                                              </b-form-input>
                                          </b-form-group>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col cols="4">
                                          <b-form-group class="p-0" id="exampleInputGroup3" label="FTP user" label-for="username">
                                              <b-form-input id="username" type="text" v-model="form.ftpDetails.USER" required >
                                              </b-form-input>
                                          </b-form-group>
                                      </b-col>
                                      <b-col cols="4">
                                          <b-form-group class="p-0" id="exampleInputGroup3" label="FTP Password" label-for="password_smtp">
                                              <password-input idFor="password_smtp" v-model="form.ftpDetails.PASS"></password-input>
                                          </b-form-group>
                                      </b-col>
                                      <b-col>
                                          <b-form-group label="Connection type" class="p-0 no-label-margin">
                                              <b-form-radio-group name="authentication" v-model="currentMode" class="custom-mode" @input="setDefaults">
                                                  <b-form-radio value="FTP">FTP</b-form-radio>
                                                  <b-form-radio value="SSL">SSL</b-form-radio>
                                                  <b-form-radio value="SFTP">SFTP</b-form-radio>
                                              </b-form-radio-group>
                                              <b-form-checkbox class="mt-2" v-model="form.ftpDetails.PASV" :value="1" :unchecked-value="0">Use passive mode</b-form-checkbox>
                                          </b-form-group>
                                      </b-col>
                                  </b-row>
                              </b-form-group>
                          </b-form>
                      </div>
                  </b-col>
              </b-row>
              <div class="card-footer text-muted text-right">
                  <b-btn variant="link" id="testConnBtn" size="sm" @click="testConnection" class="test-connection" @mouseout="removeMessage" v-if="form.isDirectFS=='N'" :disabled="buttonLoaders.testConnection"><stetho-scope class="icon-default"></stetho-scope>Test Connection
                      <spinner size="small" v-if="buttonLoaders.testConnection"></spinner>
                      <b-tooltip show ref="tooltip" target="testConnBtn" placement="top">
                          <span v-if="testConnectionMessage">
                              {{testConnectionMessage}}
                          </span>
                      </b-tooltip>
                  </b-btn>

                  <b-btn variant="primary" size="sm" @click="save" :disabled="buttonLoaders.saveChanges">Save Changes
                      <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
                  </b-btn>
              </div>
          </div>
      </b-col>
    </div>
</template>

<script>
import Vue from 'vue';

import PasswordInput from '../Common/PasswordInput';
import SuccessFilledIcon from '../../assets/successfilled.svg';
import ErrorFilledIcon from '../../assets/errorfilled.svg';
import StethoScope from '../../assets/stethoscope.svg'

export default {
  name: 'appupdatesettings',
  components: {
    PasswordInput,
    SuccessFilledIcon,
    ErrorFilledIcon,
    StethoScope
  },
  props: ['settings'],
  data() {
    return {
      buttonLoaders: {
        saveChanges: false
      },
      showToolTip: false,
      testConnectionMessage: '',
      dirSettings: {
        appDirPermission: {}
      },
      form: {},
      currentMode: 'FTP',
      selected: 'direct',
      usePassive: false,
      options: [
        {
          text: 'Direct',
          value: 'Y'
        },
        {
          text: 'FTP',
          value: 'N'
        }
      ]
    };
  },
  mounted() {
    let payload = {
      requiredData: {
        isConfigWritable: 1,
        getConfigFTP: 1,
        appDirPermission: 1
      }
    };
    if (this.settings.appUpdateSettings) {
      this.form = _.cloneDeep(this.settings.appUpdateSettings);
      if (this.form.ftpDetails == null || this.form.ftpDetails == false) {
        this.form.ftpDetails = {
          PORT: 21
        };
      } else {
        if (this.form.ftpDetails.SFTP === '1') {
          this.currentMode = 'SFTP';
        } else if (this.form.ftpDetails.SSL === '1') {
          this.currentMode = 'SSL';
        } else {
          this.currentMode = 'FTP';
        }
      }
    }
    this.$store.dispatch('sendAction', payload).then(response => {
      this.dirSettings = response.data;
    });
  },
  methods: {
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      if (this.currentMode === 'SFTP') {
        this.form.ftpDetails.SFTP = '1';
        this.form.ftpDetails.SSL = '0';
        this.form.ftpDetails.FTP = '0';
      } else if (this.currentMode === 'SSL') {
        this.form.ftpDetails.SSL = '1';
        this.form.ftpDetails.FTP = '0';
        this.form.ftpDetails.SFTP = '0';
      } else {
        this.form.ftpDetails.FTP = '1';
        this.form.ftpDetails.SFTP = '0';
        this.form.ftpDetails.SSL = '0';
      }
      payload.requiredData = {
        updateSettingsAllV3: {
          appUpdateSettings: this.form
        },
        getSettingsAllV3: 1
      };

      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    },
    setDefaults() {
      if (this.currentMode === 'SFTP' && this.form.ftpDetails.PORT == 21) {
        this.form.ftpDetails.PORT = 22;
      } else if (
        this.currentMode === 'FTP' &&
        this.form.ftpDetails.PORT == 22
      ) {
        this.form.ftpDetails.PORT = 21;
      }
    },
    removeMessage(){
      this.$refs.tooltip.$emit('close');
      this.testConnectionMessage = "";
    },
    testConnection() {
      this.testConnectionMessage = "";
      this.buttonLoaders.testConnection = true;
      let ftp_ssl = 0;
      let use_sftp = 0;
      if (this.currentMode === 'SSL') {
        ftp_ssl = 1;
      }
      if (this.currentMode === 'SFTP') {
        use_sftp = 1;
      }
      let payload = {
        requiredData: {
          FTPTestConnection: {
            hostName: this.form.ftpDetails.HOST,
            hostUserName: this.form.ftpDetails.USER,
            hostPassword: this.form.ftpDetails.PASS,
            ftp_port: this.form.ftpDetails.PORT,
            ftp_ssl: ftp_ssl,
            use_sftp: use_sftp,
            PASV: this.form.ftpDetails.PASV,
            FTPBase: this.form.ftpDetails.BASE,
            basePathValidation: true
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.testConnection = false;
        let FTPTestConnection = response.data.FTPTestConnection;
        if (FTPTestConnection && FTPTestConnection.status == 'error') {
          this.testConnectionMessage = FTPTestConnection.errorMsg;
          setTimeout(() => {
            this.$refs.tooltip.$emit('open');
          }, 100);

          //   setTimeout(() => {
          //     this.showToolTip = false;
          //   }, 3000);
        } else {
          this.testConnectionMessage = 'Test connection success';
          setTimeout(() => {
            this.$refs.tooltip.$emit('open');
          }, 100);
        }
      });
    }
  }
};
</script>

<style>
</style>
